import { useCallback } from "react";
import { createDesignHuddleProject } from "./design-huddle-sdk";

import type { TemplateCustomizationObject } from "./brand-info-customizations/types";

type createDesignHuddleContentProject = (props: {
  templateCode: string;
  customizations: TemplateCustomizationObject;
  pageNumber?: number;
}) => Promise<string>;

export const useCreateDesignHuddleProject = (): createDesignHuddleContentProject =>
  useCallback(async ({ templateCode, customizations, pageNumber }) => {
    try {
      return await createDesignHuddleProject({
        template_code: templateCode,
        customizations,
        page_number: pageNumber,
      });
    } catch (error) {
      console.error(error);
      throw new Error("Failed to create project", { cause: error });
    }
  }, []);
